import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const Casula = () => (
  <CostcoLocationTemplate
    warehouseName="Crossroads"
    suburb="Casula"
    state="New South Wales"
    stateShort="NSW"
    address="1 Town Terrace, Casula NSW 2170"
    path="/costco/casula"
    nearbySuburbs={[
      'Casula',
      'Liverpool',
      'Prestons',
      'Lurnea',
      'Moorebank',
      'Chipping Norton',
      'Hammondville',
      'Holsworthy',
      'Wattle Grove',
      'Glenfield',
    ]}
    description="Serving Costco Executive Members near the Crossroads warehouse in Casula. South-West Sydney is one of the fastest-growing corridors in the country — whether you're a first home buyer or upgrading, we can help you find the right loan and earn a Costco Shop Card at settlement."
    localContext={[
      {
        title: 'Liverpool & Casula Growth Corridor',
        description:
          'The Liverpool-Casula corridor is experiencing significant growth driven by the Western Sydney Aerotropolis, new health and education precincts, and major road upgrades. Property demand continues to rise across the region.',
      },
      {
        title: 'South-West Sydney First Home Buyers',
        description:
          'Suburbs like Casula, Prestons, and Lurnea offer competitive entry prices for first home buyers. Government incentives including stamp duty concessions and the First Home Guarantee make this area particularly accessible.',
      },
      {
        title: 'New Infrastructure & Development',
        description:
          'The South-West is benefiting from the new Western Sydney Airport, expanded rail links, and major retail and commercial developments at Liverpool and Crossroads. These investments are supporting long-term property value growth.',
      },
    ]}
    faqs={[
      {
        q: 'How do I earn a Costco Shop Card through the Crossroads warehouse?',
        a: 'The Shop Card offer is not warehouse-specific — it applies to all Costco Executive Members Australia-wide. Simply settle an eligible loan through Manage Your Loans and you will receive a Shop Card based on your loan amount. You can use it at the Crossroads warehouse in Casula or any other Costco location.',
      },
      {
        q: 'Is South-West Sydney a good area for first home buyers?',
        a: 'Yes. Suburbs around Casula and Liverpool offer some of Sydney\'s most affordable housing options with strong infrastructure investment. The Western Sydney Airport, new rail connections, and expanding commercial precincts are driving long-term growth in the region.',
      },
      {
        q: 'What loan types qualify for the Costco Shop Card offer?',
        a: 'Home loans (purchase and refinance), car loans, and other eligible lending products settled through Manage Your Loans qualify. You must be a Costco Executive Member at the time of settlement. Full terms and conditions are available on our website.',
      },
      {
        q: 'Can I use government first home buyer grants alongside the Shop Card offer?',
        a: 'Yes. Government grants and concessions such as the First Home Owner Grant, stamp duty exemptions, and the First Home Guarantee are separate from the Costco Shop Card offer. You can take advantage of both when purchasing your first home through Manage Your Loans.',
      },
    ]}
    suburbData={{
      suburb: 'Casula',
      medianHouse: '$850,000',
      medianUnit: '$520,000',
      daysOnMarket: '28 days',
      rentalYield: '3.5%',
      population: '12,000',
      distanceToCostco: '2 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Liverpool', medianHouse: '$880,000', medianUnit: '$490,000', daysOnMarket: '26 days' },
      { suburb: 'Prestons', medianHouse: '$1,020,000', medianUnit: '$560,000', daysOnMarket: '24 days' },
      { suburb: 'Lurnea', medianHouse: '$820,000', medianUnit: '$470,000', daysOnMarket: '29 days' },
      { suburb: 'Moorebank', medianHouse: '$950,000', medianUnit: '$530,000', daysOnMarket: '27 days' },
      { suburb: 'Chipping Norton', medianHouse: '$1,100,000', medianUnit: '$580,000', daysOnMarket: '23 days' },
      { suburb: 'Hammondville', medianHouse: '$890,000', medianUnit: '$500,000', daysOnMarket: '30 days' },
      { suburb: 'Holsworthy', medianHouse: '$920,000', medianUnit: '$520,000', daysOnMarket: '28 days' },
      { suburb: 'Wattle Grove', medianHouse: '$1,050,000', medianUnit: '$570,000', daysOnMarket: '25 days' },
      { suburb: 'Glenfield', medianHouse: '$870,000', medianUnit: '$480,000', daysOnMarket: '31 days' },
    ]}
  />
);

export default Casula;
